import { v4 as uuidv4 } from "uuid";
export const getReactAppVersion = () => {
  return import.meta.env.VITE_REACT_APP_VERSION ?? `local-${uuidv4()}`;
};
